import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./about.css";

const About = () => {
  return (
    <>
      {/* Hero Section */}
      <section className="about-hero">
        <Container>
          <Row>
            <Col md={12}>
              <h1>About BR Travel</h1>
              <p>
                Built on trust, driven by experience, and powered by meaningful
                relationships.
              </p>
            </Col>
          </Row>
        </Container>
      </section>

      {/* About Content */}
      <section className="about-content">
        <Container>
          <Row>
            <Col md={12}>
              <p className="intro">
                <strong>BR Travel</strong> stands for <strong>Brotherhood,
                Relationship, and Management</strong>. We are a modern travel
                company shaped by years of collective experience across travel,
                hospitality, and event management industries.
              </p>
            </Col>
          </Row>

          <Row className="about-block">
            <Col md={4}>
              <h3>Brotherhood</h3>
              <p>
                We are a close-knit team that has grown together professionally.
                Understanding each other’s strengths allows us to deliver
                thoughtful, reliable, and seamless experiences to our clients.
              </p>
            </Col>

            <Col md={4}>
              <h3>Relationship</h3>
              <p>
                At BR Travel, people come first. We believe memorable experiences
                are built on care, trust, and genuine connections — with clients,
                suppliers, and partners alike.
              </p>
            </Col>

            <Col md={4}>
              <h3>Management</h3>
              <p>
                Every journey has a purpose. We take complete ownership of our
                client’s expectations and manage every detail with precision,
                accountability, and high service standards.
              </p>
            </Col>
          </Row>

          {/* Experience */}
          <Row className="experience">
            <Col md={12}>
              <p>
                With over <strong>two decades of combined industry experience</strong>,
                our professionals go the extra mile to ensure excellence — no
                matter the scale or complexity of the requirement.
              </p>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Mission & Vision */}
      <section className="mission-vision">
        <Container>
          <Row>
            <Col md={6}>
              <div className="mv-card">
                <h3>Our Mission</h3>
                <p>
                  To be accessible, dependable, and efficient — creating real
                  value across Travel, Hospitality, and MICE services while
                  delivering consistent client satisfaction.
                </p>
              </div>
            </Col>

            <Col md={6}>
              <div className="mv-card">
                <h3>Our Vision</h3>
                <p>
                  To emerge as a trusted industry leader, adapt to changing
                  times, and grow alongside our ecosystem — building a brand
                  rooted in Brotherhood, Relationship, and Management.
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default About;
